import Vue from 'vue';
Vue.component('Echart', (resolve) => require(['@/components/Echart'], resolve));